/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Quotes",
  "description": "Displays a \"Quote of the Day\" or a random phrase in the editor's status bar and provides a settings panel to adjust the rotation interval. Modified and translated in English by GaiaWindWave90.",
  "credits": [
    {
      "name": "笑小朗",
      "link": ""
    },
    {
      "name": "GaiaWindWave90 (translator and modifier)",
      "link": ""
    },
    {
      "name": "https://developer.hitokoto.cn/",
      "link": "https://developer.hitokoto.cn/"
    },
    {
      "name": "https://card.gudong.site/",
      "link": "https://card.gudong.site/"
    },
    {
      "name": "https://www.jinrishici.com/",
      "link": "https://www.jinrishici.com/"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [],
  "settings": [
    {
      "dynamic": true,
      "name": "Enable Quotes",
      "id": "enable_daily_quote",
      "type": "boolean",
      "default": true
    },
    {
      "dynamic": true,
      "name": "Switch interval (seconds)",
      "id": "interval",
      "type": "positive_integer",
      "default": 5
    },
    {
      "dynamic": true,
      "name": "Display mode",
      "id": "display_mode",
      "type": "select",
      "default": "sequential",
      "potentialValues": [
        {
          "id": "sequential",
          "name": "Sequential"
        },
        {
          "id": "random",
          "name": "Random"
        }
      ]
    },
    {
      "dynamic": false,
      "name": "Quote Library",
      "id": "quote_library",
      "type": "select",
      "default": "local",
      "potentialValues": [
        {
          "id": "local",
          "name": "Local"
        },
        {
          "id": "hitokoto",
          "name": "A word"
        },
        {
          "id": "gudong",
          "name": "Notes on Ancient Movements"
        },
        {
          "id": "jinrishici",
          "name": "Poem of the Day"
        }
      ]
    },
    {
      "dynamic": true,
      "name": "Custom quotes (one sentence per line)",
      "id": "custom_quotes",
      "type": "string",
      "multiline": true,
      "rows": 10,
      "default": "Welcome to PotentiaMod.\nRemember to read the rules\nIs that OK that we will use some shampoo?\nDave the magical cheese wizard.\nBig challenges, you love it.\nEvery copy of PotentiaMod is personalized\nYou have seen Potentia. Hug her.\nTotal Scratching!\nI LOVE ELECTRAMOD!!!\nMaybe in another universe, PotentiaMod is based on GaiaMod\nWith PotentiaMod, we got a new Scratch experience.\nWe'll buy this mod for a dollar!\nEat my alerts list!\nCongratulations! You're about to be erased!\nThis isn't even its final form!\nEAT AT JOES\nSend in the TurboWarp Squad!\nTHE SPRUNKIS WILL RULE\nGaiaMod and PotentiaMod are the duo of Scratch mods.\nFINAL CONFLICT NEAR! YOUR MOD'S CODE GETS SCRAMBLED!\nFind the REAL PotentiaMod. Don't let it delete itself!\nBingo! Try this URL parameter, web only: \"?allpowerscombined\"\nKiwi Farms users saw this app. Shoo the scumbags!\nFind a way out before this mod attacks you!\nREMIXWARP ADDONS INCOMING!\nScratch mods are for cats!"
    }
  ],
  "tags": [
    "rw",
    "new",
    "ui",
    "daily",
    "quote"
  ],
  "enabledByDefault": true
};
export default manifest;
